import { render } from "./FormStyles.vue?vue&type=template&id=622b099f"
import script from "./FormStyles.vue?vue&type=script&lang=js"
export * from "./FormStyles.vue?vue&type=script&lang=js"

import "./FormStyles.vue?vue&type=style&index=0&id=622b099f&lang=scss"
script.render = render

export default script